// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `Container du carousel
.carousel-container {
	position: relative;
	overflow: hidden;
	height: 100vh;
	min-width: 100%;
  }
  
  .carousel {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
    width: 100vh;
  }
  
  .carousel-items {
	display: flex;
	transition: transform 0.5s ease;
  }
  
  .carousel-item {
    flex-shrink: 0;
    width: 100vh;
    height: 100vh;
    position: relative;
  }
  
  .carousel-item.active {
	opacity: 1; /* Afficher l'élément actif */
  }
  
  .carousel-item img {
	width: 100%;
	height: 100vh; /* Ajustez la hauteur du carousel */
	object-fit: cover;
  }
  
  /* Boutons de navigation */
  .carousel-button {
    position: absolute;
    top: 50%;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    font-size: 30px;
    border: none;
    padding: 10px;
    cursor: pointer;
    z-index: 1;
  }
  
  .carousel-button.prev {
    left: 10px;
    transform: translateY(-50%);
  }
  
  .carousel-button.next {
    right: 10px;
    transform: translateY(-50%);
  }
  
  /* Style des éléments du carousel */

  
  .carousel-item.active {
    display: block;
  }
  
  /* Style du contenu du carousel */

  
  .space-mobile {
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 20px;
    padding: 20px;
    position:fixed; 
  }
  
  /* Responsive - Pour les écrans plus larges (Tablettes et plus) */
  @media (min-width: 768px) {
    .text-content h1 {
      font-size: 2rem;
    }
  
    .text-content h6 {
      font-size: 1.2rem;
    }
  
    .show-text {
      font-size: 18px;
    }
  
    .filled-btn-visite, .filled-button {
      font-size: 16px;
      padding: 12px 16px;
    }
  
    .row {
      justify-content: center;
    }
  
    .col-lg-4, .col-sm-12, .col-lg-4, .col-sm-6 {
      width: auto;
    }
  }
  
  /* Responsive - Pour les petits écrans (mobiles) */
  @media (max-width: 767px) {
    .carousel {
      padding: 0 10px;
    }
  
    .text-content {
      padding: 15px;
      width: 100%;
      text-align: center;
    }
  
    .space-mobile {
      padding: 10px;
      border-radius: 15px;
      width: 20%;
    }
  
    .text-content h1 {
      font-size: 1.5rem;
    }
  
    .text-content h6 {
      font-size: 1rem;
    }
  
    .show-text {
      font-size: 14px;
    }
  
    .filled-btn-visite, .filled-button {
      font-size: 14px;
      padding: 10px;
    }
  
    .row {
      display: block;
    }
  
    .col-lg-4, .col-sm-12, .col-lg-4, .col-sm-6 {
      width: 100% !important;
      margin-bottom: 10px;
    }
  }
  
  /* Pour les très petits écrans */
  @media (max-width: 480px) {
    .text-content {
      padding: 10px;
    }
  
    .text-content h1 {
      font-size: 1.3rem;
    }
  
    .text-content h6 {
      font-size: 0.9rem;
    }
  
    .show-text {
      font-size: 12px;
    }
  
    .filled-btn-visite, .filled-button {
      font-size: 12px;
      padding: 8px;
    }
  
    .row {
      display: block;
    }
  
    .col-lg-4, .col-sm-12, .col-lg-4, .col-sm-6 {
      width: 100% !important;
      margin-bottom: 8px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/assets/css/responsive1.css"],"names":[],"mappings":"AAAA;;CAEC,kBAAkB;CAClB,gBAAgB;CAChB,aAAa;CACb,eAAe;EACd;;EAEA;CACD,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;IACpB,YAAY;EACd;;EAEA;CACD,aAAa;CACb,+BAA+B;EAC9B;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;EAEA;CACD,UAAU,EAAE,6BAA6B;EACxC;;EAEA;CACD,WAAW;CACX,aAAa,EAAE,mCAAmC;CAClD,iBAAiB;EAChB;;EAEA,0BAA0B;EAC1B;IACE,kBAAkB;IAClB,QAAQ;IACR,oCAAoC;IACpC,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,aAAa;IACb,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA,mCAAmC;;;EAGnC;IACE,cAAc;EAChB;;EAEA,iCAAiC;;;EAGjC;IACE,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;IACb,cAAc;EAChB;;EAEA,iEAAiE;EACjE;IACE;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,WAAW;IACb;EACF;;EAEA,kDAAkD;EAClD;IACE;MACE,eAAe;IACjB;;IAEA;MACE,aAAa;MACb,WAAW;MACX,kBAAkB;IACpB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,UAAU;IACZ;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,aAAa;IACf;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,sBAAsB;MACtB,mBAAmB;IACrB;EACF;;EAEA,gCAAgC;EAChC;IACE;MACE,aAAa;IACf;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,YAAY;IACd;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,sBAAsB;MACtB,kBAAkB;IACpB;EACF","sourcesContent":["Container du carousel\n.carousel-container {\n\tposition: relative;\n\toverflow: hidden;\n\theight: 100vh;\n\tmin-width: 100%;\n  }\n  \n  .carousel {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n    width: 100vh;\n  }\n  \n  .carousel-items {\n\tdisplay: flex;\n\ttransition: transform 0.5s ease;\n  }\n  \n  .carousel-item {\n    flex-shrink: 0;\n    width: 100vh;\n    height: 100vh;\n    position: relative;\n  }\n  \n  .carousel-item.active {\n\topacity: 1; /* Afficher l'élément actif */\n  }\n  \n  .carousel-item img {\n\twidth: 100%;\n\theight: 100vh; /* Ajustez la hauteur du carousel */\n\tobject-fit: cover;\n  }\n  \n  /* Boutons de navigation */\n  .carousel-button {\n    position: absolute;\n    top: 50%;\n    background-color: rgba(0, 0, 0, 0.5);\n    color: white;\n    font-size: 30px;\n    border: none;\n    padding: 10px;\n    cursor: pointer;\n    z-index: 1;\n  }\n  \n  .carousel-button.prev {\n    left: 10px;\n    transform: translateY(-50%);\n  }\n  \n  .carousel-button.next {\n    right: 10px;\n    transform: translateY(-50%);\n  }\n  \n  /* Style des éléments du carousel */\n\n  \n  .carousel-item.active {\n    display: block;\n  }\n  \n  /* Style du contenu du carousel */\n\n  \n  .space-mobile {\n    background-color: rgba(0, 0, 0, 0.6);\n    border-radius: 20px;\n    padding: 20px;\n    position:fixed; \n  }\n  \n  /* Responsive - Pour les écrans plus larges (Tablettes et plus) */\n  @media (min-width: 768px) {\n    .text-content h1 {\n      font-size: 2rem;\n    }\n  \n    .text-content h6 {\n      font-size: 1.2rem;\n    }\n  \n    .show-text {\n      font-size: 18px;\n    }\n  \n    .filled-btn-visite, .filled-button {\n      font-size: 16px;\n      padding: 12px 16px;\n    }\n  \n    .row {\n      justify-content: center;\n    }\n  \n    .col-lg-4, .col-sm-12, .col-lg-4, .col-sm-6 {\n      width: auto;\n    }\n  }\n  \n  /* Responsive - Pour les petits écrans (mobiles) */\n  @media (max-width: 767px) {\n    .carousel {\n      padding: 0 10px;\n    }\n  \n    .text-content {\n      padding: 15px;\n      width: 100%;\n      text-align: center;\n    }\n  \n    .space-mobile {\n      padding: 10px;\n      border-radius: 15px;\n      width: 20%;\n    }\n  \n    .text-content h1 {\n      font-size: 1.5rem;\n    }\n  \n    .text-content h6 {\n      font-size: 1rem;\n    }\n  \n    .show-text {\n      font-size: 14px;\n    }\n  \n    .filled-btn-visite, .filled-button {\n      font-size: 14px;\n      padding: 10px;\n    }\n  \n    .row {\n      display: block;\n    }\n  \n    .col-lg-4, .col-sm-12, .col-lg-4, .col-sm-6 {\n      width: 100% !important;\n      margin-bottom: 10px;\n    }\n  }\n  \n  /* Pour les très petits écrans */\n  @media (max-width: 480px) {\n    .text-content {\n      padding: 10px;\n    }\n  \n    .text-content h1 {\n      font-size: 1.3rem;\n    }\n  \n    .text-content h6 {\n      font-size: 0.9rem;\n    }\n  \n    .show-text {\n      font-size: 12px;\n    }\n  \n    .filled-btn-visite, .filled-button {\n      font-size: 12px;\n      padding: 8px;\n    }\n  \n    .row {\n      display: block;\n    }\n  \n    .col-lg-4, .col-sm-12, .col-lg-4, .col-sm-6 {\n      width: 100% !important;\n      margin-bottom: 8px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
